import styled, { css, keyframes } from 'styled-components';

const fadeInUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    height: auto;
  `}
`;

export const HotelCardWrapper = styled.div`
  ${({ theme }) => css`
    animation: ${fadeInUp} 0.6s ease-out forwards;
    animation-fill-mode: both;
    opacity: 0;
  `}
`;
